import { Environment } from '../models/environment.model';

export class EnvironmentLoader {
    private static env: Environment;

    public static get environment(): Environment {
        return EnvironmentLoader.env;
    }

    public static async loadEnvironment(): Promise<void> {
        const response = await fetch(
            `${document.querySelector('base')?.getAttribute('href') ?? '/'}assets/config/environment.json`,
        );
        try {
            EnvironmentLoader.env = await response.json();
        } catch (err) {
            console.error(err, 'Could not load config');
        }
    }
}
